/* Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial */
import type { Session } from "../ClientContext";
import { Config } from "../config/Config";
export async function updateJoinAccount(command: string, userId: string, code?: string): Promise<void> {
  const raw=localStorage.getItem("matrix-auth-store");
  const previous=raw ? JSON.parse(raw) as Session : undefined;
  if(command==="clear") {
    // An origin message alone cannot log anybody out. Verify server revocation
    // and match the exact permanent account; never clear an anonymous guest.
    if(!previous || previous.passwordlessUser || previous.user_id!==userId)return;
    const status=await fetch("/api/auth/join-session/status",{method:"POST",headers:{Authorization:`Bearer ${previous.access_token}`}});
    if(status.status!==401 && status.status!==403)throw Error("Session has not been revoked");
    if(localStorage.getItem("matrix-auth-store")===raw)localStorage.removeItem("matrix-auth-store");
    return;
  }
  if(command!=="sync" || !code || !/^[A-Za-z0-9_-]{43}$/.test(code))throw Error("Invalid account update");
  const response=await fetch("/api/auth/join-session/exchange",{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json"},body:JSON.stringify({code})});
  if(!response.ok)throw Error("Session exchange failed");
  const data=await response.json(),session=data.session as Session;
  if(data.sessionOnly!==true || data.matrixRoomId || data.recordingId || session?.user_id!==userId || session.passwordlessUser || !session.access_token || !session.device_id ||
     new URL(session.homeserver_url!).origin!==new URL(Config.defaultHomeserverUrl()!).origin)throw Error("Session verification failed");
  // Do not overwrite a session changed while the network request was pending.
  if(localStorage.getItem("matrix-auth-store")!==raw)throw Error("Account changed during synchronization");
  const same=previous?.access_token===session.access_token && previous?.device_id===session.device_id;
  if(!same)localStorage.setItem("matrix-auth-store",JSON.stringify({...session,reset_crypto:true}));
}
